<template>
  <div v-if="!loading">
    <v-container fluid>
      <v-row>
        <!-- Správanie vo VTOS -->
        <v-col
          v-if="'spravanie_vo_vtos_silne' in form"
          cols="12"
          lg="6"
        >
          <SwotCard
            title="Správanie vo VTOS"
            color="red lighten-2"
            icon="mdi-meditation"
            :values="{
              silne: form.spravanie_vo_vtos_silne,
              slabe: form.spravanie_vo_vtos_slabe,
              prilezitosti: form.spravanie_vo_vtos_prilezitosti,
              ohrozenia: form.spravanie_vo_vtos_ohrozenia,
            }"
            :info-keys="{
              silne: 'spravanie_silne',
              slabe: 'spravanie_slabe',
              prilezitosti: 'spravanie_prilezitosti',
              ohrozenia: 'spravanie_ohrozenia',
            }"
            :manual="manual"
            :readonly="form.closed"
            @update:silne="form.spravanie_vo_vtos_silne = $event"
            @update:slabe="form.spravanie_vo_vtos_slabe = $event"
            @update:prilezitosti="form.spravanie_vo_vtos_prilezitosti = $event"
            @update:ohrozenia="form.spravanie_vo_vtos_ohrozenia = $event"
          />
        </v-col>

        <!-- Rodina, vzťahy a komunita -->
        <v-col
          v-if="'rodina_silne' in form"
          cols="12"
          lg="6"
        >
          <SwotCard
            title="Rodina, vzťahy a komunita"
            color="pink lighten-2"
            icon="mdi-home-heart"
            :values="{
              silne: form.rodina_silne,
              slabe: form.rodina_slabe,
              prilezitosti: form.rodina_prilezitosti,
              ohrozenia: form.rodina_ohrozenia,
            }"
            :info-keys="{
              silne: 'rodina_silne',
              slabe: 'rodina_slabe',
              prilezitosti: 'rodina_prilezitosti',
              ohrozenia: 'rodina_ohrozenia',
            }"
            :manual="manual"
            :readonly="form.closed"
            @update:silne="form.rodina_silne = $event"
            @update:slabe="form.rodina_slabe = $event"
            @update:prilezitosti="form.rodina_prilezitosti = $event"
            @update:ohrozenia="form.rodina_ohrozenia = $event"
          />
        </v-col>
      </v-row>

      <v-row>
        <!-- Bývanie -->
        <v-col
          v-if="'byvanie_silne' in form"
          cols="12"
          lg="6"
        >
          <SwotCard
            title="Bývanie"
            color="blue lighten-2"
            icon="mdi-home"
            :values="{
              silne: form.byvanie_silne,
              slabe: form.byvanie_slabe,
              prilezitosti: form.byvanie_prilezitosti,
              ohrozenia: form.byvanie_ohrozenia,
            }"
            :info-keys="{
              silne: 'byvanie_silne',
              slabe: 'byvanie_slabe',
              prilezitosti: 'byvanie_prilezitosti',
              ohrozenia: 'byvanie_ohrozenia',
            }"
            :manual="manual"
            :readonly="form.closed"
            @update:silne="form.byvanie_silne = $event"
            @update:slabe="form.byvanie_slabe = $event"
            @update:prilezitosti="form.byvanie_prilezitosti = $event"
            @update:ohrozenia="form.byvanie_ohrozenia = $event"
          />
        </v-col>

        <!-- Vzdelanie -->
        <v-col
          v-if="'vzdelanie_silne' in form"
          cols="12"
          lg="6"
        >
          <SwotCard
            title="Vzdelanie"
            color="purple lighten-2"
            icon="mdi-school"
            :values="{
              silne: form.vzdelanie_silne,
              slabe: form.vzdelanie_slabe,
              prilezitosti: form.vzdelanie_prilezitosti,
              ohrozenia: form.vzdelanie_ohrozenia,
            }"
            :info-keys="{
              silne: 'vzdelanie_silne',
              slabe: 'vzdelanie_slabe',
              prilezitosti: 'vzdelanie_prilezitosti',
              ohrozenia: 'vzdelanie_ohrozenia',
            }"
            :manual="manual"
            :readonly="form.closed"
            @update:silne="form.vzdelanie_silne = $event"
            @update:slabe="form.vzdelanie_slabe = $event"
            @update:prilezitosti="form.vzdelanie_prilezitosti = $event"
            @update:ohrozenia="form.vzdelanie_ohrozenia = $event"
          />
        </v-col>
      </v-row>

      <v-row>
        <!-- Zamestnanie -->
        <v-col
          v-if="'zamestnanie_silne' in form"
          cols="12"
          lg="6"
        >
          <SwotCard
            title="Zamestnanie"
            color="teal lighten-2"
            icon="mdi-briefcase"
            :values="{
              silne: form.zamestnanie_silne,
              slabe: form.zamestnanie_slabe,
              prilezitosti: form.zamestnanie_prilezitosti,
              ohrozenia: form.zamestnanie_ohrozenia,
            }"
            :info-keys="{
              silne: 'zamestnanie_silne',
              slabe: 'zamestnanie_slabe',
              prilezitosti: 'zamestnanie_prilezitosti',
              ohrozenia: 'zamestnanie_ohrozenia',
            }"
            :manual="manual"
            :readonly="form.closed"
            @update:silne="form.zamestnanie_silne = $event"
            @update:slabe="form.zamestnanie_slabe = $event"
            @update:prilezitosti="form.zamestnanie_prilezitosti = $event"
            @update:ohrozenia="form.zamestnanie_ohrozenia = $event"
          />
        </v-col>

        <!-- Financie -->
        <v-col
          v-if="'financie_silne' in form"
          cols="12"
          lg="6"
        >
          <SwotCard
            title="Financie"
            color="green lighten-2"
            icon="mdi-currency-usd"
            :values="{
              silne: form.financie_silne,
              slabe: form.financie_slabe,
              prilezitosti: form.financie_prilezitosti,
              ohrozenia: form.financie_ohrozenia,
            }"
            :info-keys="{
              silne: 'financie_silne',
              slabe: 'financie_slabe',
              prilezitosti: 'financie_prilezitosti',
              ohrozenia: 'financie_ohrozenia',
            }"
            :manual="manual"
            :readonly="form.closed"
            @update:silne="form.financie_silne = $event"
            @update:slabe="form.financie_slabe = $event"
            @update:prilezitosti="form.financie_prilezitosti = $event"
            @update:ohrozenia="form.financie_ohrozenia = $event"
          />
        </v-col>
      </v-row>

      <v-row>
        <!-- Voľný čas -->
        <v-col
          v-if="'volny_cas_silne' in form"
          cols="12"
          lg="6"
        >
          <SwotCard
            title="Voľný čas"
            color="orange lighten-2"
            icon="mdi-run"
            :values="{
              silne: form.volny_cas_silne,
              slabe: form.volny_cas_slabe,
              prilezitosti: form.volny_cas_prilezitosti,
              ohrozenia: form.volny_cas_ohrozenia,
            }"
            :info-keys="{
              silne: 'volny_cas_silne',
              slabe: 'volny_cas_slabe',
              prilezitosti: 'volny_cas_prilezitosti',
              ohrozenia: 'volny_cas_ohrozenia',
            }"
            :manual="manual"
            :readonly="form.closed"
            @update:silne="form.volny_cas_silne = $event"
            @update:slabe="form.volny_cas_slabe = $event"
            @update:prilezitosti="form.volny_cas_prilezitosti = $event"
            @update:ohrozenia="form.volny_cas_ohrozenia = $event"
          />
        </v-col>
      </v-row>

      <!-- Additional form fields (continued from original) -->
      <v-row v-if="'pracovne_zrucnosti' in form">
        <v-col cols="12">
          <v-card>
            <v-card-title>Pracovné zručnosti získané v rámci práce počas VTOS</v-card-title>
            <v-card-text>
              <v-textarea
                v-model="form.pracovne_zrucnosti"
                label="Pracovné zručnosti"
                auto-grow
                dense
                rows="3"
                :readonly="form.closed"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Sociálny podnik -->
      <v-row v-if="'socialny_podnik_dostupny' in form">
        <v-col cols="12">
          <v-card>
            <v-card-title>Sociálny podnik</v-card-title>
            <v-card-text>
              <v-switch
                v-model="form.socialny_podnik_dostupny"
                label="Dostupný sociálny podnik"
                :readonly="form.closed"
              />
              
              <!-- Social businesses table (if exists in original) -->
              <div
                v-if="form.socialne_podniky && form.socialne_podniky.length > 0"
                class="mt-4"
              >
                <v-data-table
                  :headers="socialne_podniky_headers"
                  :items="form.socialne_podniky"
                  class="elevation-1"
                >
                  <template #[`item.status`]="{ item }">
                    <v-chip
                      :color="getStatusColor(item.status)"
                      small
                    >
                      {{ item.status }}
                    </v-chip>
                  </template>
                </v-data-table>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Závislosť a liečba -->
      <v-row v-if="'zaujem_dobrovolna_liecba' in form">
        <v-col cols="12">
          <v-card>
            <v-card-title>Závislosť a následná starostlivosť</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="6">
                  <v-switch
                    v-model="form.zaujem_dobrovolna_liecba"
                    label="Záujem o dobrovoľnú liečbu"
                    :readonly="form.closed"
                  />
                </v-col>
                <v-col cols="6">
                  <v-switch
                    v-model="form.zabezpecena_nadvazna_starostlivost"
                    label="Zabezpečená nadväzná starostlivosť"
                    :readonly="form.closed"
                  />
                </v-col>
              </v-row>
              <v-textarea
                v-if="form.zabezpecena_nadvazna_starostlivost"
                v-model="form.zabezpecena_nadvazna_starostlivost_text"
                label="Popis nadväznej starostlivosti"
                auto-grow
                dense
                rows="2"
                :readonly="form.closed"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Spolupráca s obcou -->
      <v-row v-if="'poziadal_o_spolupracu_obec' in form">
        <v-col cols="12">
          <v-card>
            <v-card-title>Spolupráca s obcou</v-card-title>
            <v-card-text>
              <v-switch
                v-model="form.poziadal_o_spolupracu_obec"
                label="Požiadal o spoluprácu s obcou"
                :readonly="form.closed"
              />
              <v-textarea
                v-if="form.poziadal_o_spolupracu_obec"
                v-model="form.poziadal_o_spolupracu_obec_text"
                label="Popis spolupráce"
                auto-grow
                dense
                rows="2"
                :readonly="form.closed"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Form Actions -->
      <v-divider class="my-6" />
      <FormActions
        ref="formActions"
        v-if="!form.closed"
        :is-dirty="isDirty"
        :loading="loading"
        :fixed="false"
        save-text="Uložiť"
        @save="updateItem"
      />
    </v-container>

    <!-- Info Dialog -->
    </div>

  <div v-else>
    <form-skeleton-component skeleton_type="Swot" />
  </div>
</template>

<script>
import { ref, reactive, onMounted } from '@vue/composition-api';
import { useRoute } from '@/composables/useRouter.js';
import { APIService } from "@/http/APIService.js";
import FormSkeleton from "../components/FormSkeleton.vue";
import SwotCard from "@/components/SwotCard.vue";
import FormActions from "@/components/FormActions.vue";
import { useIapszForm } from "@/composables/useIapszForm.js";
import { useFormDirty } from "@/composables/useFormDirty.js";

const apiService = new APIService();

export default {
  components: {
    "form-skeleton-component": FormSkeleton,
    SwotCard,
    FormActions,
  },

  setup() {
    const route = useRoute();

    // Use composables
    const { loading, setLoading, handleSaveSuccess, handleSaveError } = useIapszForm();

    // Form state
    const form = ref({
      id: null,
      spravanie_vo_vtos_silne: "",
      spravanie_vo_vtos_slabe: "",
      spravanie_vo_vtos_prilezitosti: "",
      spravanie_vo_vtos_ohrozenia: "",
      rodina_silne: "",
      rodina_slabe: "",
      rodina_prilezitosti: "",
      rodina_ohrozenia: "",
      byvanie_silne: "",
      byvanie_slabe: "",
      byvanie_prilezitosti: "",
      byvanie_ohrozenia: "",
      vzdelanie_silne: "",
      vzdelanie_slabe: "",
      vzdelanie_prilezitosti: "",
      vzdelanie_ohrozenia: "",
      zamestnanie_silne: "",
      zamestnanie_slabe: "",
      zamestnanie_prilezitosti: "",
      zamestnanie_ohrozenia: "",
      financie_silne: "",
      financie_slabe: "",
      financie_prilezitosti: "",
      financie_ohrozenia: "",
      volny_cas_silne: "",
      volny_cas_slabe: "",
      volny_cas_prilezitosti: "",
      volny_cas_ohrozenia: "",
      pracovne_zrucnosti: "",
      socialny_podnik_dostupny: false,
      zaujem_dobrovolna_liecba: false,
      zabezpecena_nadvazna_starostlivost: false,
      zabezpecena_nadvazna_starostlivost_text: "",
      poziadal_o_spolupracu_obec: false,
      poziadal_o_spolupracu_obec_text: "",
      socialne_podniky: [],
    });

    // Track dirty state - create separate initial state reference
    const initialForm = ref({});
    const { isDirty, markAsPristine, enableBrowserWarning } = useFormDirty(initialForm, form, { deep: true });
    enableBrowserWarning();

    // Table headers
    const socialne_podniky_headers = [
      { text: 'Dátum', value: 'created_at' },
      { text: 'Názov', value: 'socialny_podnik.kontaktne_udaje_nazov' },
      { text: 'Miesto', value: 'socialny_podnik.miesto_cinnosti_a_aktivit' },
      { text: 'Email', value: 'socialny_podnik.email' },
      { text: 'Stav', value: 'status' },
      { text: 'Služby', value: 'socialny_podnik.ubytovanie' },
      { text: 'Akcie', value: 'id' },
    ];

    // Manual/help text - configured for showInfo composable
    // Note: Help is now displayed inline in SwotCard components
    const manual = reactive({
      spravanie_silne: {
        nazov: "Správanie vo VTOS - Silné stránky",
        priklady: "akceptácia autorít, schopnosť ovládať svoju agresivitu, triezvy pohľad na prijatie situácie, komunikatívnosť, zmysel pre humor, dobré vzťahy s ostatnými klientmi, spolupráca, schopnosť prijať pravidlá",
      },
      spravanie_slabe: {
        nazov: "Správanie vo VTOS - Slabé stránky",
        priklady: "ignorácia a nerešpektovanie autorít, neschopnosť sebaovládania, problematické vzťahy s ostatnými klientmi, pasivita, vnútorné neprijatie trestu",
      },
      spravanie_prilezitosti: {
        nazov: "Správanie vo VTOS - Príležitosti",
        priklady: "vhodné rozvojové aktivity a programy, pozitívne interakcie",
      },
      spravanie_ohrozenia: {
        nazov: "Správanie vo VTOS - Ohrozenia",
        priklady: "nevhodne zvolené aktivity a programy, nevhodné zaradenie klienta",
      },
      rodina_silne: {
        nazov: "Rodina, vzťahy a komunita - Silné stránky",
        priklady: "pozitívny vzťah k rodine, záujem o dieťa, pravidelná korešpondencia a kontakt s rodinou",
      },
      rodina_slabe: {
        nazov: "Rodina, vzťahy a komunita - Slabé stránky",
        priklady: "negatívny vzťah k rodine, nezáujem o dieťa, neschopnosť vychovávať dieťa, absentujúci kontakt s rodinou (osobný, písomný)",
      },
      rodina_prilezitosti: {
        nazov: "Rodina, vzťahy a komunita - Príležitosti",
        priklady: "funkčnosť rodinných vzťahov, vhodne zvolený program zameraný na rodinu, rodinné konferencie, sanačné programy, inštitút opustenia ústavu",
      },
      rodina_ohrozenia: {
        nazov: "Rodina, vzťahy a komunita - Ohrozenia",
        priklady: "dieťa so špeciálnymi potrebami, nefunkčnosť rodinných vzťahov",
      },
      byvanie_silne: {
        nazov: "Bývanie - Silné stránky",
        priklady: "vlastnícky vzťah k nehnuteľnosti, zodpovedný prístup k otázke bývania (platby načas, nájomná zmluva...)",
      },
      byvanie_slabe: {
        nazov: "Bývanie - Slabé stránky",
        priklady: "bezdomovectvo, opakovane vyhodený z domu, odchovanec DeD bez skúseností s vhodným bývaním",
      },
      byvanie_prilezitosti: {
        nazov: "Bývanie - Príležitosti",
        priklady: "zabezpečené bývanie (u rodičov, podnájom...), dostupné ubytovanie v rámci sociálnych služieb (útulky, nocľahárne, DSS)",
      },
      byvanie_ohrozenia: {
        nazov: "Bývanie - Ohrozenia",
        priklady: "nedostupné sociálne služby spojené s bývaním, nehnuteľnosť s ťarchou (hrozba dražby), nedostatok ekonomicky dostupného bývania, nereálne očakávania, návrat do kriminogénneho prostredia",
      },
      vzdelanie_silne: {
        nazov: "Vzdelanie - Silné stránky",
        priklady: "vysokoškolské vzdelanie, maturita, výučný list, absolvované kurzy, ochota vzdelávať sa",
      },
      vzdelanie_slabe: {
        nazov: "Vzdelanie - Slabé stránky",
        priklady: "nevzdelávateľný, negramotný, bez vzdelania, základné vzdelanie, slabá motivácia",
      },
      vzdelanie_prilezitosti: {
        nazov: "Vzdelanie - Príležitosti",
        priklady: "rekvalifikačné kurzy, možnosť ďalšieho vzdelávania (výučný list, maturita...)",
      },
      vzdelanie_ohrozenia: {
        nazov: "Vzdelanie - Ohrozenia",
        priklady: "nedostatok vhodných vzdelávacích príležitostí (kurzy...), nedostatočná podpora okolia",
      },
      zamestnanie_silne: {
        nazov: "Zamestnanie - Silné stránky",
        priklady: "trvalé pracovné návyky, pracovné skúsenosti, ochota cestovať za zamestnaním, ochota zmeniť zamestnávateľa",
      },
      zamestnanie_slabe: {
        nazov: "Zamestnanie - Slabé stránky",
        priklady: "žiadne pracovné návyky, absencia pracovných skúseností, nechce cestovať za prácou",
      },
      zamestnanie_prilezitosti: {
        nazov: "Zamestnanie - Príležitosti",
        priklady: "ponuka práce, udržateľné zamestnanie, podpora zamestnávateľa",
      },
      zamestnanie_ohrozenia: {
        nazov: "Zamestnanie - Ohrozenia",
        priklady: "nedostatok pracovných príležitostí, diskriminácia na trhu práce, zdravotné obmedzenia",
      },
      financie_silne: {
        nazov: "Financie - Silné stránky",
        priklady: "úspory, finančná gramotnosť, zabezpečený príjem, schopnosť hospodáriť",
      },
      financie_slabe: {
        nazov: "Financie - Slabé stránky",
        priklady: "zadlženosť, exekúcie, neschopnosť hospodáriť, závislosti pohlcujúce financie",
      },
      financie_prilezitosti: {
        nazov: "Financie - Príležitosti",
        priklady: "možnosť splátkového kalendára, finančné poradenstvo, sociálne dávky",
      },
      financie_ohrozenia: {
        nazov: "Financie - Ohrozenia",
        priklady: "rastúce dlhy, nemožnosť splácania, strata príjmu",
      },
      volny_cas_silne: {
        nazov: "Voľný čas - Silné stránky",
        priklady: "záujmy, hobby, pozitívne aktivity, športové aktivity",
      },
      volny_cas_slabe: {
        nazov: "Voľný čas - Slabé stránky",
        priklady: "žiadne záujmy, pasivita, rizikové aktivity",
      },
      volny_cas_prilezitosti: {
        nazov: "Voľný čas - Príležitosti",
        priklady: "dostupné kluby, športové zariadenia, kultúrne aktivity",
      },
      volny_cas_ohrozenia: {
        nazov: "Voľný čas - Ohrozenia",
        priklady: "nedostatok možností, kriminogénne prostredie, negatívny vplyv",
      },
    });

    // Initialize info dialog with manual data
    // Methods
    const getItem = () => {
      setLoading(true);
      apiService
        .getIapszSwot(route.params.id)
        .then((response) => {
          form.value = response;
          initialForm.value = JSON.parse(JSON.stringify(response));
          markAsPristine();
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    };

    const formActions = ref(null);

    const updateItem = () => {
      apiService
        .updateIapszSwot(form.value, route.params.id)
        .then(
          () => {
            handleSaveSuccess();
            markAsPristine();
            if (formActions.value) {
              formActions.value.showSuccess();
            }
          },
          () => {
            handleSaveError();
            if (formActions.value) {
              formActions.value.showError();
            }
          }
        );
    };

    const getStatusColor = (status) => {
      const colors = {
        'Schválený': 'success',
        'Čakajúci': 'warning',
        'Zamietnutý': 'error',
      };
      return colors[status] || 'grey';
    };

    // Lifecycle
    onMounted(() => {
      getItem();
    });

    return {
      // State
      loading,
      form,
      manual,
      socialne_podniky_headers,
      isDirty,
      formActions,

      // Methods
      updateItem,
      getStatusColor,
    };
  },

  beforeRouteLeave(to, from, next) {
    if (this.isDirty) {
      if (window.confirm('Máte neuložené zmeny. Naozaj chcete odísť?')) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
};
</script>

<style scoped>
/* Custom styles if needed */
</style>
